var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "pa-0", attrs: { flat: "" } },
    [
      _c(
        "v-card-title",
        { staticClass: "my-0 py-0" },
        [
          _c(
            "v-container",
            { staticClass: "pa-0", attrs: { fluid: "" } },
            [
              _c(
                "v-row",
                { staticClass: "d-flex align-center" },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "1" }, on: { click: _vm.openDialog } },
                    [_c("v-icon", [_vm._v("mdi-filter-variant")])],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass:
                        "chip-filter filter-select py-0 mb-2 datatableFilter hidden-sm-and-down",
                      attrs: { cols: "6" }
                    },
                    _vm._l(_vm.filters, function(filter) {
                      return _c(
                        "div",
                        { key: filter.name },
                        [
                          _c(
                            "v-chip",
                            {
                              staticClass: "ma-1",
                              attrs: {
                                color: filter.color,
                                outlined: "",
                                small: ""
                              }
                            },
                            [
                              _c(
                                "v-avatar",
                                {
                                  staticClass: "my-5 white--text",
                                  attrs: { left: "", color: filter.color }
                                },
                                [_vm._v(_vm._s(filter.type))]
                              ),
                              _vm._v(" " + _vm._s(filter.name) + " ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  _c(
                    "v-dialog",
                    {
                      attrs: { width: "75%", persistent: "" },
                      model: {
                        value: _vm.dialog,
                        callback: function($$v) {
                          _vm.dialog = $$v
                        },
                        expression: "dialog"
                      }
                    },
                    [
                      _c("TicketFilter", {
                        on: {
                          closeDialog: _vm.closeDialog,
                          getFilters: _vm.setFilters
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "py-0 d-flex align-center" },
                    [
                      _c("v-text-field", {
                        staticClass: "mt-0",
                        attrs: {
                          "append-icon": "mdi-magnify",
                          label: "Buscar",
                          "single-line": ""
                        },
                        model: {
                          value: _vm.search,
                          callback: function($$v) {
                            _vm.search = $$v
                          },
                          expression: "search"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.items,
          search: _vm.search,
          options: _vm.optionsTickets,
          "items-per-page": _vm.itemsPerPage[1],
          "items-per-page-options": _vm.itemsPerPage,
          "footer-props": {
            itemsPerPageOptions: _vm.itemsPerPage,
            itemsPerPageText: "Cantidad de Tickets por página",
            prevIcon: "",
            nextIcon: "",
            pageText: ""
          },
          loading: _vm.dataLoad,
          "loading-text": _vm.loadingText,
          "no-data-text": _vm.noDataText,
          expanded: [],
          "show-expand": _vm.showDetails,
          "single-expand": "",
          "item-key": "serial"
        },
        on: {
          "update:options": function($event) {
            _vm.optionsTickets = $event
          },
          "item-expanded": _vm.openDetail
        },
        scopedSlots: _vm._u([
          {
            key: "no-data",
            fn: function() {
              return [_vm._v("No hay datos disponibles")]
            },
            proxy: true
          },
          {
            key: "no-results",
            fn: function() {
              return [_vm._v("No se encontraron resultados")]
            },
            proxy: true
          },
          {
            key: "item.action",
            fn: function(ref) {
              var item = ref.item
              return [
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-2",
                    attrs: { small: "" },
                    on: {
                      click: function($event) {
                        return _vm.editItem(item)
                      }
                    }
                  },
                  [_vm._v("mdi-pencil")]
                ),
                _c(
                  "v-icon",
                  {
                    attrs: { small: "" },
                    on: {
                      click: function($event) {
                        return _vm.fireWarning(item)
                      }
                    }
                  },
                  [_vm._v("mdi-delete")]
                )
              ]
            }
          },
          {
            key: "item.state",
            fn: function(ref) {
              var item = ref.item
              return [
                _c(
                  "v-chip",
                  { attrs: { color: item.state.color, dark: "", small: "" } },
                  [_vm._v(_vm._s(item.state.name))]
                )
              ]
            }
          },
          {
            key: "item.actions",
            fn: function(ref) {
              var item = ref.item
              return [
                _c(
                  "span",
                  [
                    _c("v-icon", { staticClass: "text-center" }, [
                      _vm._v(_vm._s(item.actions))
                    ])
                  ],
                  1
                )
              ]
            }
          },
          {
            key: "expanded-item",
            fn: function(ref) {
              var headers = ref.headers
              var item = ref.item
              return [
                _c("td"),
                _c(
                  "td",
                  { attrs: { colspan: headers.length - 1 } },
                  [
                    _c(
                      "v-skeleton-loader",
                      {
                        staticClass: "my-2",
                        attrs: {
                          color: "#eceff1",
                          loading: _vm.waitingForDetails,
                          type: "list-item@3"
                        }
                      },
                      [
                        _c(
                          "v-list",
                          { attrs: { color: "transparent", "three-line": "" } },
                          [
                            _c("v-subheader", [
                              _c(
                                "h4",
                                { staticClass: "overline green--text" },
                                [
                                  _vm._v(
                                    " Detalles del Ticket #" +
                                      _vm._s(item.serial) +
                                      " "
                                  )
                                ]
                              )
                            ]),
                            _c("v-divider"),
                            _c(
                              "v-list-item",
                              [
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c("v-list-item-subtitle", [
                                      _c("strong", [_vm._v("Asunto:")]),
                                      _vm._v(
                                        " " + _vm._s(_vm.itemDetail.name) + " "
                                      )
                                    ]),
                                    _c("v-list-item-subtitle", [
                                      _c("strong", [_vm._v("Estatus:")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(item.state.originalStatus) +
                                          " "
                                      )
                                    ]),
                                    _c("v-list-item-subtitle", [
                                      _c("strong", [_vm._v("Contacto:")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.itemDetail.contact.name) +
                                          " " +
                                          _vm._s(
                                            _vm.itemDetail.contact.lastName
                                          ) +
                                          " "
                                      ),
                                      _vm.itemDetail.contact.ci
                                        ? _c("span", [
                                            _vm._v(
                                              "- " +
                                                _vm._s(
                                                  _vm.itemDetail.contact.ci
                                                )
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm.itemDetail.contact.position
                                        ? _c("span", [
                                            _vm._v(
                                              "(" +
                                                _vm._s(
                                                  _vm.itemDetail.contact
                                                    .position
                                                ) +
                                                ")"
                                            )
                                          ])
                                        : _vm._e()
                                    ]),
                                    _c("v-list-item-subtitle", [
                                      _c("strong", [
                                        _vm._v("Fecha de Creación:")
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.itemDetail.creationDate) +
                                          " "
                                      )
                                    ]),
                                    _c("v-list-item-subtitle", [
                                      _c("strong", [
                                        _vm._v("Fecha de Cierre:")
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.itemDetail.closingDate) +
                                          " "
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }